export default "__VITE_ASSET__WIETtLR2__"